import isAuth from "../../../components/IsAuth/IsAuth"
import SavedSearch from "../../../components/SavedSearch/SavedSearch"


const SavedSearchPage = () => {
    return <SavedSearch/>
}   

export default isAuth(SavedSearchPage)